
export const getEnvironment = (state) => state.environment;

export const getHasConnection = (state) => state.environment.hasConnection;